module.exports = __webpack_public_path__ + "media/images/lp/industries/issue_taxi_sp-3c8e28066594dc569213d77e6391916b.svg";